import React from 'react';
import { Navigate, Outlet, RouteProps } from 'react-router-dom';
import { AppRoutes } from '../enums';

export interface IProtectedRouteProps {
	allowed: boolean;
	activated: boolean;
}

export interface IUserRedirectProps {
	loggedInPath: string; //the path we redirect the user to if he's logged in
	allowed: boolean;
}

export const IsUserRedirect: React.FC<IUserRedirectProps & RouteProps> = ({ allowed, loggedInPath, children }) => {
	return !allowed ? (
		<Outlet />
	) : (
		<Navigate
			replace
			to={{
				pathname: loggedInPath
			}}
		/>
	);
};

export const ProtectedRoute: React.FC<IProtectedRouteProps & RouteProps> = ({ allowed, activated }) => {
	if (allowed) {
		if (activated) {
			return <Outlet />;
		} else {
			return <Navigate replace to={{ pathname: AppRoutes.ACCOUNT_CONFIRMATION }} />;
		}
	} else {
		return <Navigate replace to={{ pathname: AppRoutes.SIGNIN }} />;
	}
};
